import * as tslib_1 from "tslib";
import React from 'react';
import NativeCheckbox from 'sinoui-components/Checkbox';
import PropTypes from 'prop-types';
import Field from './Field';
export function renderCheckboxField(_a) {
    var children = _a.children, props = _a.props, field = _a.field, form = _a.form;
    return (React.createElement(NativeCheckbox, tslib_1.__assign({ dense: true }, props, field, { checked: field.value === props.value, error: form.touched[field.name] && form.errors[field.name], id: field.name, onBlur: function () { return form.setFieldTouched(field.name, true); }, onChange: function (event, checked) {
            form.setFieldValue(field.name, checked ? props.value : props.unCheckedValue);
        } }), children));
}
/**
 * 复选框组件
 */
var Checkbox = function (_a, _b) {
    var checkboxGroup = _b.checkboxGroup;
    var children = _a.children, props = tslib_1.__rest(_a, ["children"]);
    if (checkboxGroup) {
        return (React.createElement(NativeCheckbox, tslib_1.__assign({}, props, { className: "sinoui-checkbox-field" }), children));
    }
    return (React.createElement(Field, tslib_1.__assign({}, props, { render: function (_a) {
            var field = _a.field, form = _a.form;
            return renderCheckboxField({ field: field, form: form, children: children, props: props });
        } })));
};
Checkbox.contextTypes = {
    checkboxGroup: PropTypes.bool,
};
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map